// 기기 데이터 변환/매핑 관련 유틸리티 함수들

// [삼성 모델 정렬 로직] 최신 출시(세대) 우선 정렬을 위한 유틸 함수
// - 시리즈별 숫자 추출: S25, Z Flip7, Z Fold5, Note20, A55, J8 등
// - "5G" 표기는 세대와 무관하므로 제거 후 판별
// - 숫자가 없으면 1세대로 간주 (예: Galaxy Z Flip, Galaxy Fold)
export const getSamsungModelGeneration = (seriesName: string, modelName: string): number => {
  const s = seriesName.toLowerCase();
  const n0 = modelName.toLowerCase();
  const n = n0.replace(/\b5g\b/g, '').replace(/\s+/g, ' ').trim();
  const numAfter = (keyword: string) => {
    const r = new RegExp(`${keyword}\\s*(\\d+)`, 'i');
    const m = n.match(r);
    return m ? parseInt(m[1], 10) : null;
  };
  // 시리즈별 우선 키워드 기반 추출
  if (s.includes('galaxy s')) {
    const g = numAfter('s') ?? (n.match(/\b(\\d{1,3})\b/) ? parseInt(n.match(/\b(\\d{1,3})\b/)! [1], 10) : null);
    return g ?? 0;
  }
  if (s.includes('z flip')) {
    // Z Flip 세대: "z flip 3", "flip3" 등 숫자 존재 시 그 값, 없으면 1세대 처리 ("z flip", "z flip 5g")
    const m1 = n.match(/z\s*flip\s*(\d+)/i) || n.match(/flip\s*(\d+)/i);
    if (m1) return parseInt(m1[1], 10);
    return (n.includes('z flip') || n.includes('flip')) ? 1 : 0;
  }
  if (s.includes('z fold')) {
    // Z Fold 세대: 숫자 존재 시 그 값. "galaxy fold"(Z 없는 1세대)는 1 처리
    if (n.includes('galaxy fold') && !n.includes('z fold')) return 1;
    const m1 = n.match(/z\s*fold\s*(\d+)/i) || n.match(/fold\s*(\d+)/i);
    if (m1) return parseInt(m1[1], 10);
    return (n.includes('fold')) ? 1 : 0;
  }
  if (s.includes('note')) {
    const g = numAfter('note');
    return g ?? 0;
  }
  if (s.includes(' galaxy a') || s.endsWith('galaxy a') || s.includes('galaxy a')) {
    const g = numAfter('a');
    return g ?? 0;
  }
  if (s.includes(' galaxy j') || s.endsWith('galaxy j') || s.includes('galaxy j')) {
    const g = numAfter('j');
    return g ?? 0;
  }
  // 기본: 이름 내 숫자 (5G 등 통신 표기는 제거된 상태)
  const any = n.match(/\b(\\d{1,3})\b/);
  return any ? parseInt(any[1], 10) : 0;
};

// 동일 세대 내 변형 우선순위: Ultra > Plus/Pro > 기본 > FE/Lite 등
export const getSamsungVariantPriority = (modelName: string): number => {
  const n = modelName.toLowerCase();
  if (n.includes('ultra')) return 3;
  if (n.includes('plus') || n.includes('pro')) return 2;
  if (n.includes('fe') || n.includes('lite')) return 0;
  return 1; // 기본형
};
